const gql = String.raw
import { sendNwReqWithAuth } from './network'

const getAllSettings = async siteName => {
  const QUERY = gql`
  query GlobalSettings {
    ${siteName}GlobalSettings
  }
  `

  const response = await sendNwReqWithAuth(QUERY)
  const siteSettingsField = `${siteName}GlobalSettings`

  let globalSetting
  try {
    globalSetting = JSON.parse(response?.data?.[siteSettingsField])
  } catch (err) {
    console.log('Global Settings Parse error:', err)
  }

  return globalSetting || {}
}

export default getAllSettings
